if(!customElements.get('newsletter-form')) {
  class NewsletterForm extends HTMLElement {
    constructor() {
      super();

      this.elForm = this.querySelector('form');
      this.elInputs = this.elForm.querySelectorAll('input');
      this.elMessage = this.querySelector('[data-message]');
      this.elPopup = this.closest('popup-modals');
      
      this.source = this.getAttribute('source');

      this.elForm.addEventListener('submit', this.submitForm.bind(this));
      this.elInputs.forEach(el => el.addEventListener('focus', this.resetForm.bind(this)));
    }

    submitForm(ev) {
      ev.preventDefault();
      if(!window.wb_apihelper) return;

      const props = Object.assign(
        {
          vendor: 'shopify-subscribe',
          action: 'subscribe',
          signup_location: this.source
        }, 
        ...[...this.elInputs].map(input => {
          const { name } = input.dataset;
          return { [name]: input.value }
        })
      )

      this.classList.add('submitting');
      window.wb_apihelper(props, (err, res) => {
        this.classList.remove('submitting');

        if(err) {
          let message = '';
          this.classList.add('error');
          this.elInputs.forEach(el => {
            const { name } = el.dataset;
            if(res.message.includes(name)) {
              el.setAttribute('aria-invalid', true);
              message = `${message} Enter a valid ${name}`;
            };
          })
          this.elMessage.innerHTML = message;
        } else {
          this.classList.add('success');
          this.elMessage.innerHTML = 'Thank you for subscribing';
          this.elPopup && setTimeout(() => {
            this.elPopup.closeActivePopup();
          }, 2000)
        }
        
        console.log(err, res);
        setTimeout(() => this.resetForm(), 3000);
      })
    }

    setErrorSuccessState(err) {
      this.classList.toggle('error', err);
      this.classList.toggle('success', !err);
    }

    resetForm() {
      this.elInputs.forEach(el => el.setAttribute('aria-invalid', false));
      this.elMessage.innerHTML = '';
      this.classList.remove('submitting');
      this.classList.remove('success');
      this.classList.remove('error');
    }
  }

  customElements.define('newsletter-form', NewsletterForm);
}